"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalitiesSection = void 0;
const dropdown_input_1 = require("@app/component/ui/forms/dropdown-input/dropdown-input");
const form_grid_layout_1 = require("@app/component/ui/forms/form-grid-layout");
const util_1 = require("@app/util");
const react_1 = __importDefault(require("react"));
const shift_modal_section_1 = require("../components/shift-modal-section");
const shift_context_1 = require("../shift-context");
const use_my_localities_1 = require("../util/use-my-localities");
const LocalitiesSection = () => {
    const { formControl, disabledEditation } = (0, shift_context_1.useShift)();
    const localityOptions = (0, use_my_localities_1.useMyLocalities)();
    return (react_1.default.createElement(shift_modal_section_1.ShiftModalSection, { id: 'localities' },
        react_1.default.createElement(form_grid_layout_1.FormGridLayout, null,
            react_1.default.createElement(dropdown_input_1.DropdownInput, { options: localityOptions, control: formControl, name: 'localityId', disabled: (0, util_1.isDefined)(disabledEditation) }))));
};
exports.LocalitiesSection = LocalitiesSection;
